export default {"src":"/_next/static/media/phone.e0ddd24a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};